import { featureCollection } from "@turf/helpers";
import { MarketplaceMetalTier } from "@app/overviews/market-expansion-dashboard/shared/MarketplaceCountyPlanCounts";

/** Placeholder GeoJSON data for a mapbox `Source` before its real data has loaded. */
export const EMPTY_FEATURE_COLLECTION = featureCollection([]);

export const SELECTED_COUNTY_SOURCE_ID = "selected-county-source";
export const SELECTED_COUNTY_BORDER_LAYER_ID = "selected-county-border-layer";

export const HOVERED_COUNTY_SOURCE_ID = "hovered-county-source";
export const HOVERED_COUNTY_BORDER_LAYER_ID = "hovered-county-border-layer";

// Membership
export const MEMBERSHIP_SHADED_COUNTY_SOURCE_ID = "membership-shaded-county-source";
export const MEMBERSHIP_SHADED_COUNTY_BORDER_LAYER_ID = "membership-shaded-county-border-layer";
export const MEMBERSHIP_SHADED_COUNTY_FILL_LAYER_ID = "membership-shaded-county-fill-layer";

// Provider Landscape
export const PROVIDER_LANDSCAPE_SHADED_COUNTY_SOURCE_ID = "provider-landscape-shaded-county-source";
export const PROVIDER_LANDSCAPE_SHADED_COUNTY_BORDER_LAYER_ID = "provider-landscape-shaded-county-border-layer";
export const PROVIDER_LANDSCAPE_SHADED_COUNTY_FILL_LAYER_ID = "provider-landscape-shaded-county-fill-layer";

// Provider Footprint
export const PROVIDER_FOOTPRINT_COUNTY_SOURCE_ID = "provider-footprint-county-source";
export const PROVIDER_FOOTPRINT_COUNTY_BORDER_LAYER_ID = "provider-footprint-county-border-layer";
export const PROVIDER_FOOTPRINT_PROVIDER_SOURCE_ID = "provider-footprint-provider-source";
export const PROVIDER_FOOTPRINT_PROVIDER_LAYER_ID = "provider-footprint-provider-layer";
export const PROVIDER_FOOTPRINT_SELECTED_CE_LAYER_ID = "provider-footprint-selected-ce-layer";
export const PROVIDER_FOOTPRINT_SELECTED_CE_SOURCE_ID = "provider-footprint-selected-ce-source";
export const MAX_PROVIDER_CIRCLE_SIZE = 25;
export const MIN_PROVIDER_CIRCLE_SIZE = 7;
export const PROVIDER_FOOTPRINT_CLICK_PIXEL_RADIUS = 10;
export const MAP_BOUNDS_PROVIDER_CLUSTER_PADDING = 75;
export const PROVIDER_FOOTPRINT_MAX_ZOOM = 15;
export const PROVIDER_FOOTPRINT_MAX_ZOOM_ON_POINT = 1; // In miles

export const MAP_BOUNDS_PADDING = 50;
export const MAP_BOUNDS_COUNTY_PADDING = 25;
export const MAP_PAN_DURATION = 1000;
export const MAP_DEFAULT_ZOOM = 3.2;

export const COUNTY_SHADING_BASE = 0.5;

export const COUNTY_SHADING_MAX_AMETHYST_THEME = "#8236A5";
export const COUNTY_SHADING_MIN_AMETHYST_THEME = "#F6EAFF";

export const COUNTY_SHADING_MAX_AZURE_THEME = "#10395E";
export const COUNTY_SHADING_MIN_AZURE_THEME = "#C6D9EA";

export const COUNTY_SHADING_MAX_JADE_THEME = "#0E4A38";
export const COUNTY_SHADING_MIN_JADE_THEME = "#A8E6CF";

export const COUNTY_OUTLINE_COLORS = {
  hovered: "rgba(255, 214, 84, 1)",
  selected: "#056EDF"
};

export const COUNTY_SUMMARY_POPUP_ENROLLMENT_COLOR = "#056EDF4D";

export const LEGEND_BACKGROUND_COLOR = '#FFFFFF';
export const LEGEND_BOX_SHADOW_COLOR = '#00000040';

export const MARKET_SHARE_COLORS = [
  { sliceColor: "#1D65AB", textColor: "#f9f9ff" },
  { sliceColor: "#C6D9EA", textColor: "#32323c" },
  { sliceColor: "#5B579C", textColor: "#f9f9ff" },
  { sliceColor: "#ADABCD", textColor: "#32323c" },
  { sliceColor: "#006E8C", textColor: "#f9f9ff" },
  { sliceColor: "#00A6D6", textColor: "#f9f9ff" },
  { sliceColor: "#80D2EA", textColor: "#32323c" }
];

export const MARKET_SHARE_COLORS_OTHER = {
  sliceColor: "#10395E", textColor: "#f9f9ff"
}

export const RADIAN = Math.PI / 180;

export const CONTRACT_ENTITY_DETAILS_TABLE_PAGE_SIZE = 5;

export const METAL_TIER_DISPLAY_CONFIG: Record<MarketplaceMetalTier, { color: string; label: string }> = {
  [MarketplaceMetalTier.bronze]: { color: "#B4912F", label: "Bron" },
  [MarketplaceMetalTier.silver]: { color: "#9CA3B0", label: "Silv" },
  [MarketplaceMetalTier.gold]: { color: "#FCB415", label: "Gold" },
  [MarketplaceMetalTier.platinum]: { color: "#6B7281", label: "Plat" },
  [MarketplaceMetalTier.catastrophic]: { color: "#D0D5DD", label: "Cata" },
  [MarketplaceMetalTier.low]: { color: "#D2BD82", label: "Low" },
  [MarketplaceMetalTier.high]: { color: "#876D23", label: "High" },
  [MarketplaceMetalTier.expandedBronze]: { color: "#C68A42", label: "Exp. Bron" },
  [MarketplaceMetalTier.unknown]: { color: 'red', label: "Unk" },
};

export const METAL_TIER_ORDER: MarketplaceMetalTier[] = [
  MarketplaceMetalTier.bronze,
  MarketplaceMetalTier.silver,
  MarketplaceMetalTier.gold,
  MarketplaceMetalTier.platinum,
  MarketplaceMetalTier.catastrophic,
  MarketplaceMetalTier.low,
  MarketplaceMetalTier.high,
  MarketplaceMetalTier.expandedBronze,
  MarketplaceMetalTier.unknown,
];